<template>
  <p v-if="showStopTip" class="stop-project flex-align">
    <i class="el-icon-circle-close" style="margin-right: 10px"></i>
    该项目已终止{{ procurementName }}

    <el-button
      v-if="showCloseDetailButton"
      type="text"
      class="m-l-16"
      @click="toAbortiveDetail"
    >
      流标详情
    </el-button>
  </p>
</template>

<script>
export default {
  name: 'ProjectClosed',

  props: {
    showStopTip: {
      type: Boolean,
      default: false
    },

    showCloseDetailButton: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    // 根据路由判断采购类型，招标、询比、竞价
    procurementName() {
      const _pathArr = this.$route.path.split('/')
      const _type = _pathArr[2]
      const _obj = {
        bidding: '招标',
        inquiry: '询比',
        compete: '竞价'
      }
      return _obj[_type]
    }
  },

  methods: {
    toAbortiveDetail() {
      this.$emit('toAbortiveDetail')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.stop-project {
  width: 100%;
  background-color: $danger-fourth-color;
  color: $danger-color;
  font-size: pixel-to-rem($n: 20);
  border-radius: pixel-to-rem($n: 10);
  box-sizing: border-box;
  overflow: auto;
  position: relative;
  margin: pixel-to-rem($n: 20) 0;
  padding: pixel-to-rem($n: 30) pixel-to-rem($n: 30);

  i {
    font-size: pixel-to-rem($n: 30);
  }
}
</style>
